import firebase from 'firebase/app';
import 'firebase/auth';

import React from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';

const LogoutWrapper = styled.div`
  padding: 1em 1.5em;
`;

class Home extends React.Component {
  componentDidMount () {
    firebase.auth().signOut();
  }

  render () {
    return (
      <LogoutWrapper>
        <h1>Logging you out...</h1>

        <p>See you next time!</p>

        {!this.props.user &&
          <Redirect to="/" />}
      </LogoutWrapper>
    )
  };
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Logout.jsx